<template lang="pug">
  .component-vehicle-list.row.column
    cards(:data="parsedReports")
    vehicle-list-form(@filterVehicles="setSearch")
    base-list(:component="component", :dataLoader="dataLoader", :search="search")
</template>

<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'

  import StatisticsCard7 from "components/structure/ui/StatisticsCard7";
  import VehicleListForm from "components/structure/ui/filters/VehicleListForm";
  import BaseList from "./BaseList";
  import Cards from "../../components/structure/Cards";
  import {mapState} from 'vuex'

  export default {
    name: "VehicleSlotList",
    components: {
      Cards,
      BaseList,
      VehicleListForm,
      StatisticsCard7,
    },
    data: function () {
      return {
        component: require('src/components/backoffice/Vehicle.vue'),
        reports: null,
        search: null
      }
    },
    computed: {
     ...mapState({
      configuration: state => state.configuration,
    }),
      parsedReports: function () {
        if (!this.reports) {
          return []
        }

        return [
          {
            title: "Total Driven distance",
            value: this.reports.total_driven_km.toFixed(0)+ `${this.configuration.locale.locale_distance_unit.value}`
          },
          {
            title: "Reservation / day",
            value: this.reports.reservations_per_day
          },
          {
            title: "Maintenance Res.",
            value: this.reports.total_maintenance_reservation + " (" + this.reports.average_maintenance_reservations.toFixed(2) + "%" + ")"
          },
          {
            title: "Res. number",
            value: this.reports.total_reservation_number
          },
          {
            title: "Reserved hours.",
            value: this.reports.total_reserved_hours + "h"
          },
          {
            title: "Fleet allocation.",
            value: this.reports.vehicle_allocation + "%"
          },
        ]
      }
    },
    created() {
      this.getReports()
    },
    methods: {
      setSearch(search) {
        console.log(search)
        this.search = search
      },
      dataLoader(callback, page, resultsPerPage, search) {
        KeplerBackofficeSdk.vehicles.list(page, resultsPerPage).all(search, (items) => {
          if (search && search.active !== null) {


            items.items.forEach((item, index) => {
              if (search.active && item.slot_disabled === 1) {
              } else if (search.active && item.slot_disabled === 0) {
                items.items.splice(index, 1)
              }
            })
          }
          callback(items)
        })
      },
      getReports() {
        const range = {
          start: this.$date().startOf('month').subtract(1, 'month').format("YYYY-MM-DD"),
          end: this.$date().endOf('month').subtract(1, 'month').format("YYYY-MM-DD"),
        }

        KeplerBackofficeSdk.reports.list(range).vehicles((data) => {
          this.reports = data
        })
      },
    },
  }
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// VehicleList.vue?43a3eda0